import React from 'react';

const AssignViewDifferentProfileContext = React.createContext(false);

export default AssignViewDifferentProfileContext;
